import angular from 'angular';
import gridHeight from '../core/shared-service/grid-utils';
import Referential from '../referentials/Referential.data';

class listReferentialsPrincipalCtrl {
    /*  @ngInject */

    constructor($state, PrincipalSvc, $stateParams, logger, AuthSvc, CompanyService, PrincipalsDA) {
        this.$state = $state
        this.$principalSvc = PrincipalSvc
        this.$principalDao = PrincipalsDA
        this.$stateParams = $stateParams
        this.logger = logger
        this.authSvc = AuthSvc
        this.CompanyService = CompanyService
    }

    $onInit() {
        this.doneLoadingRef = false;
        this.doneLoadingRefCom = false;

        this.$principalDao.getPrincipal(this.$stateParams.id).then(data => {
            this.querySearchCriteria = {
                model: true,
                control: true,
                principalId: data.detail.id,
                clientCode: data.detail.eid
            }
            this.getCommunityPrincipalReferentials(this.querySearchCriteria);
            this.getPrincipalReferentials(this.querySearchCriteria);
        })
        this.isAuthorisedToEdit = this.authSvc.isAuthorized('CONFIGURATOR');
    }

    getCommunityPrincipalReferentials() {
        this.CompanyService.searchByCriterias({ principalId: this.querySearchCriteria.principalId })
            .$promise
            .then(companies => {
                if (companies && companies.length > 0) {
                    this.findReferentialsOfCommunitiesByIds(this.querySearchCriteria.principalId, companies);
                } else {
                    this.doneLoadingRefCom = true;
                    this.displayDoComRefs = false;
                    this.noResultComDoRef = true;
                }
            }).catch(error => {
                this._onError(error);
            })
    }

    findReferentialsOfCommunitiesByIds(principalId, companies) {
        let companyIds = [];
        companies.forEach(company => companyIds.push(company.companyId));
        this.$principalSvc.findReferentialsOfCommunitiesByIds(principalId, companyIds).then(data => {
            this.doneLoadingRefCom = true;
            if (data && data.length > 0) {
                this.mode = 'success.update_all';
                this.referentialsOfCommunity = []
                data.forEach(element => this.referentialsOfCommunity.push(element));
                this.referentialsOfCommunity.some((refCom, index, array) => {
                    this.displayDoComRefs = refCom.referentials && refCom.referentials.length > 0
                    return this.displayDoComRefs || index === array.length - 1
                })
            } else {
                this.displayDoComRefs = false;
                this.noResultComDoRef = true;
            }
        }).catch(error => {
            this._onError(error)
            this.noResultComDoRef = true;
        })
    }

    getPrincipalReferentials() {
        this.$principalSvc.getAllReferentialsOfPrincipal(this.querySearchCriteria)
            .then(data => {
                this.doneLoadingRef = true;
                let referentials = [];
                if (data) {
                    referentials = this.buildReferentialList(data)
                }
                this.doRefs = referentials;
                if (this.doRefs.length > 0) {
                    this.displayDoRefs = true;
                    if (this.doRefs[0].id) {
                        this.mode = 'success.update_all';
                    } else {
                        this.mode = 'success.create_all';
                    }
                } else {
                    this.noDoResult = true;
                    this.displayDoRefs = false;
                }
            }).catch(error => {
                this._onError(error);
                this.noDoResult = true;
            })
    }

    displayLoading() {
        return !(this.doneLoadingRef && this.doneLoadingRefCom);
    }
    displayNoResults() {
        return this.noDoResult && this.noResultComDoRef;
    }
    save() {
        this.doneLoadingRef = false;
        this.$principalSvc.saveAllReferentials(this.querySearchCriteria.principalId, {
            referentials: this.doRefs,
            comReferentials: this.referentialsOfCommunity,
            referentialSearchQuery: this.querySearchCriteria
        }).then(data => {
                let referentials = [];
                if (data) {
                    referentials = this.buildReferentialList(data)
                }
                this.doRefs = referentials;
                this._onSaveSuccess(this.mode)
            })
            .catch(error => {
                this._onError(error)
            })
            .finally(() => {
                this.doneLoadingRef = true;
            })
    }
    buildReferentialList(referentialDtos) {
        let referentials = [];
        referentialDtos.forEach(element => {
            referentials.push(new Referential(element, 'PRINCIPAL', this.querySearchCriteria.clientCode))
        })
        return referentials;
    }

    _onSaveSuccess(message /*:string*/) {
        this.logger.success(message, null, null, { entityName: 'Référentiels' });
    }

    _onError(error) {
        if (error.data.code === 'GET_REFERENTIALS_FAILED') {
            this.logger.error('error.get_referentials_failed');
        } else if (error.data.code === 'SAVE_REFERENTIALS_FAILED') {
            this.logger.error('error.save_referentials_failed');
        } else {
            this.logger.error('Une erreur est survenue');
        }
    }

    getGridHeight(gridApi) {
        return gridHeight(gridApi);
    }

    cancel() {
        this.$onInit();
    }

    backList() {
        this.$state.go('do', { tabName: 'principal' });
    }

}

angular.module('app.principal').component('listReferentialsPrincipal', {
    templateUrl: require('./list-referentials-principal.html'),
    controller: listReferentialsPrincipalCtrl,
    bindings: {}
});
